import { render, staticRenderFns } from "./PricingBlock.vue?vue&type=template&id=8412e2cc&scoped=true&"
import script from "./PricingBlock.vue?vue&type=script&lang=js&"
export * from "./PricingBlock.vue?vue&type=script&lang=js&"
import style0 from "./PricingBlock.vue?vue&type=style&index=0&id=8412e2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8412e2cc",
  null
  
)

export default component.exports